// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Axios = require("bs-axios/src/axios.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var LogIO = require("../LogIO.bs.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var TypeUtils = require("../types/TypeUtils.bs.js");
var AxiosUtils = require("../AxiosUtils.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_Invoice = require("../types/CommonTypes_Invoice.bs.js");
var CommonTypes_Business_Id = require("../types/business/CommonTypes_Business_Id.bs.js");

var Token = TypeUtils.MakeOpaqueStringType({});

var Id = TypeUtils.MakeOpaqueIntType({});

function toInvoiceNinjaUrl(param) {
  return Relude_Globals.$great$great(CommonTypes_Invoice.ExternalInvoiceId.toString, (function (param) {
                return "https://app.invoiceninja.com/invoices/" + param;
              }), param);
}

var url = "https://app.invoiceninja.com/api/v1/clients";

function getUrlByBusinessId(businessId) {
  return url + ("?id_number=" + encodeURIComponent(Curry._1(CommonTypes_Business_Id.toString, businessId)));
}

var Client = {
  Id: Id,
  toInvoiceNinjaUrl: toInvoiceNinjaUrl,
  url: url,
  getUrlByBusinessId: getUrlByBusinessId
};

var ContactKey = TypeUtils.MakeOpaqueStringType({});

var Id$1 = TypeUtils.MakeOpaqueIntType({});

var $$Number = TypeUtils.MakeOpaqueStringType({});

function decode(json) {
  return Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$$great, (function (productKey, notes, cost, quantity) {
                            return {
                                    product_key: productKey,
                                    notes: notes,
                                    cost: cost,
                                    qty: quantity
                                  };
                          }), Curry._3(Json.Decode.field, "product_key", Json.Decode.string, json)), Curry._3(Json.Decode.field, "notes", Json.Decode.string, json)), Curry._3(Json.Decode.field, "cost", Json.Decode.floatFromNumber, json)), Curry._3(Json.Decode.field, "qty", Json.Decode.floatFromNumber, json));
}

var Item = {
  decode: decode
};

function decode$1(json) {
  return Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$$great, (function (amount, balance, clientId, id, invoiceDate, invoiceItems, invoiceNumber) {
                                        return {
                                                amount: amount,
                                                balance: balance,
                                                client_id: clientId,
                                                id: id,
                                                invoice_date: invoiceDate,
                                                invoice_items: invoiceItems,
                                                invoice_number: invoiceNumber
                                              };
                                      }), Curry._3(Json.Decode.field, "amount", Json.Decode.floatFromNumber, json)), Curry._3(Json.Decode.field, "balance", Json.Decode.floatFromNumber, json)), Curry._3(Json.Decode.field, "client_id", Id.decode, json)), Curry._3(Json.Decode.field, "id", Id$1.decode, json)), Curry._3(Json.Decode.field, "invoice_date", Json.Decode.date, json)), Curry._3(Json.Decode.field, "invoice_items", Curry._1(Json.Decode.array, decode), json)), Curry._3(Json.Decode.field, "invoice_number", $$Number.decode, json));
}

var apiUrl = "https://app.invoiceninja.com/api/v1/invoices/";

var appUrl = "https://app.invoiceninja.com/invoices/";

function getApiInvoiceUrlForId(id) {
  return apiUrl + Curry._1(Id$1.toString, id);
}

function getAppInvoiceUrlForId(id) {
  return appUrl + (Curry._1(Id$1.toString, id) + "/edit");
}

var Invoice = {
  Id: Id$1,
  $$Number: $$Number,
  Item: Item,
  decode: decode$1,
  apiUrl: apiUrl,
  appUrl: appUrl,
  getApiInvoiceUrlForId: getApiInvoiceUrlForId,
  getAppInvoiceUrlForId: getAppInvoiceUrlForId
};

function getClientIdByBusinessId(token) {
  var partial_arg = AxiosUtils.makeNetworkCallAndDecode(undefined, {
        headers: Axios.$$Headers.fromDict(Js_dict.fromList({
                  hd: [
                    "Content-Type",
                    "application/json"
                  ],
                  tl: {
                    hd: [
                      "X-Ninja-Token",
                      Curry._1(Token.toString, token)
                    ],
                    tl: /* [] */0
                  }
                }))
      }, undefined, Curry._2(Json.Decode.field, "data", Curry._1(Json.Decode.array, Curry._2(Json.Decode.field, "id", Id.decode))));
  var partial_arg$1 = function (param) {
    return Relude_Globals.$great$great(getUrlByBusinessId, partial_arg, param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$1, (function (param) {
                  return LogIO.map(undefined, undefined, undefined, Relude_Array.head, param);
                }), param);
  };
}

function getInvoiceById(token) {
  var partial_arg = AxiosUtils.makeNetworkCallAndDecode(undefined, {
        headers: Axios.$$Headers.fromDict(Js_dict.fromList({
                  hd: [
                    "Content-Type",
                    "application/json"
                  ],
                  tl: {
                    hd: [
                      "X-Ninja-Token",
                      Curry._1(Token.toString, token)
                    ],
                    tl: /* [] */0
                  }
                }))
      }, undefined, Curry._2(Json.Decode.field, "data", decode$1));
  return function (param) {
    return Relude_Globals.$great$great(getApiInvoiceUrlForId, partial_arg, param);
  };
}

function createInvoice(token, body) {
  return AxiosUtils.makeNetworkCallAndDecode(body, {
                headers: Axios.$$Headers.fromDict(Js_dict.fromList({
                          hd: [
                            "Content-Type",
                            "application/json"
                          ],
                          tl: {
                            hd: [
                              "X-Ninja-Token",
                              Curry._1(Token.toString, token)
                            ],
                            tl: /* [] */0
                          }
                        }))
              }, /* Post */1, Curry._2(Json.Decode.field, "data", decode$1))(apiUrl);
}

var Api = {
  getClientIdByBusinessId: getClientIdByBusinessId,
  getInvoiceById: getInvoiceById,
  createInvoice: createInvoice
};

exports.Token = Token;
exports.Client = Client;
exports.ContactKey = ContactKey;
exports.Invoice = Invoice;
exports.Api = Api;
/* Token Not a pure module */
